import React from 'react';
import { ReactComponent as Close } from '../../assets/svg/close.svg';


export default function SelectFilter(props) {
  const {
    item, data, stateSetter, title, setOnRemove,
  } = props;
  return (
    <div className="filter-selected">
      <span>
        {title}
	      :
        {item.name}
      </span>
      <button
        type="button"
        onClick={() => {
				  const filteredArray = data.filter((itemInner) => item !== itemInner);
				  stateSetter(filteredArray);
	        setOnRemove(true);
        }}
        className="filter-close"
      >
        <Close />
      </button>
    </div>
  );
}
